"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var DateStyle;
(function (DateStyle) {
    DateStyle["Long"] = "Long";
    DateStyle["Short"] = "Short";
    DateStyle["Humanize"] = "Humanize";
    DateStyle["Time"] = "Time";
})(DateStyle = exports.DateStyle || (exports.DateStyle = {}));
exports.dateStyle = (_a = {},
    _a[DateStyle.Long] = {
        weekday: 'long',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
    },
    _a[DateStyle.Short] = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    },
    _a[DateStyle.Humanize] = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    },
    _a[DateStyle.Time] = {
        hour: '2-digit',
        minute: '2-digit',
    },
    _a);
var Weekday;
(function (Weekday) {
    Weekday["Sunday"] = "sunday";
    Weekday["Monday"] = "monday";
    Weekday["Tuesday"] = "tuesday";
    Weekday["Wednesday"] = "wednesday";
    Weekday["Thursday"] = "thursday";
    Weekday["Friday"] = "friday";
    Weekday["Saturday"] = "saturday";
})(Weekday = exports.Weekday || (exports.Weekday = {}));
exports.DEFAULT_WEEK_START_DAY = Weekday.Sunday;
exports.WEEK_START_DAYS = new Map([
    // Saturday
    ['AE', Weekday.Saturday],
    ['AF', Weekday.Saturday],
    ['BH', Weekday.Saturday],
    ['DZ', Weekday.Saturday],
    ['EG', Weekday.Saturday],
    ['IQ', Weekday.Saturday],
    ['IR', Weekday.Saturday],
    ['JO', Weekday.Saturday],
    ['KW', Weekday.Saturday],
    ['LY', Weekday.Saturday],
    ['OM', Weekday.Saturday],
    ['QA', Weekday.Saturday],
    ['SA', Weekday.Saturday],
    ['SY', Weekday.Saturday],
    ['YE', Weekday.Saturday],
    // Sunday
    ['AR', Weekday.Sunday],
    ['BO', Weekday.Sunday],
    ['BR', Weekday.Sunday],
    ['BZ', Weekday.Sunday],
    ['CA', Weekday.Sunday],
    ['CL', Weekday.Sunday],
    ['CO', Weekday.Sunday],
    ['CR', Weekday.Sunday],
    ['DO', Weekday.Sunday],
    ['EC', Weekday.Sunday],
    ['GT', Weekday.Sunday],
    ['HK', Weekday.Sunday],
    ['HN', Weekday.Sunday],
    ['IL', Weekday.Sunday],
    ['JM', Weekday.Sunday],
    ['JP', Weekday.Sunday],
    ['KE', Weekday.Sunday],
    ['KR', Weekday.Sunday],
    ['MO', Weekday.Sunday],
    ['MX', Weekday.Sunday],
    ['NI', Weekday.Sunday],
    ['PA', Weekday.Sunday],
    ['PE', Weekday.Sunday],
    ['PH', Weekday.Sunday],
    ['SG', Weekday.Sunday],
    ['SV', Weekday.Sunday],
    ['TW', Weekday.Sunday],
    ['US', Weekday.Sunday],
    ['VE', Weekday.Sunday],
    ['ZA', Weekday.Sunday],
    ['ZW', Weekday.Sunday],
    // Monday
    ['AD', Weekday.Monday],
    ['AL', Weekday.Monday],
    ['AM', Weekday.Monday],
    ['AU', Weekday.Monday],
    ['AZ', Weekday.Monday],
    ['BE', Weekday.Monday],
    ['BG', Weekday.Monday],
    ['BN', Weekday.Monday],
    ['BY', Weekday.Monday],
    ['CH', Weekday.Monday],
    ['CN', Weekday.Monday],
    ['CZ', Weekday.Monday],
    ['DE', Weekday.Monday],
    ['DK', Weekday.Monday],
    ['EE', Weekday.Monday],
    ['ES', Weekday.Monday],
    ['FI', Weekday.Monday],
    ['FR', Weekday.Monday],
    ['GB', Weekday.Monday],
    ['GE', Weekday.Monday],
    ['GF', Weekday.Monday],
    ['GR', Weekday.Monday],
    ['HR', Weekday.Monday],
    ['HU', Weekday.Monday],
    ['ID', Weekday.Monday],
    ['IE', Weekday.Monday],
    ['IN', Weekday.Monday],
    ['IS', Weekday.Monday],
    ['IT', Weekday.Monday],
    ['KG', Weekday.Monday],
    ['KZ', Weekday.Monday],
    ['LB', Weekday.Monday],
    ['LT', Weekday.Monday],
    ['LU', Weekday.Monday],
    ['LV', Weekday.Monday],
    ['MA', Weekday.Monday],
    ['MC', Weekday.Monday],
    ['MK', Weekday.Monday],
    ['MN', Weekday.Monday],
    ['MY', Weekday.Monday],
    ['NL', Weekday.Monday],
    ['NO', Weekday.Monday],
    ['NZ', Weekday.Monday],
    ['PK', Weekday.Monday],
    ['PL', Weekday.Monday],
    ['PT', Weekday.Monday],
    ['PY', Weekday.Monday],
    ['RO', Weekday.Monday],
    ['RS', Weekday.Monday],
    ['RU', Weekday.Monday],
    ['SE', Weekday.Monday],
    ['SK', Weekday.Monday],
    ['TH', Weekday.Monday],
    ['TN', Weekday.Monday],
    ['TR', Weekday.Monday],
    ['UA', Weekday.Monday],
    ['UY', Weekday.Monday],
    ['UZ', Weekday.Monday],
    ['VN', Weekday.Monday],
    ['XK', Weekday.Monday],
]);
/* eslint-disable line-comment-position */
// See https://en.wikipedia.org/wiki/Right-to-left
exports.RTL_LANGUAGES = [
    'ae',
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'he',
    'ku',
    'mzn',
    'nqo',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi',
];
/* eslint-enable */
var currency_decimal_places_1 = require("./currency-decimal-places");
exports.currencyDecimalPlaces = currency_decimal_places_1.default;
exports.DEFAULT_DECIMAL_PLACES = currency_decimal_places_1.DEFAULT_DECIMAL_PLACES;
exports.EASTERN_NAME_ORDER_FORMATTERS = new Map([
    [
        'ko',
        function (firstName, lastName, full) {
            return full ? "" + lastName + firstName : lastName;
        },
    ],
    [
        'ja',
        function (firstName, lastName, full) {
            return full ? "" + lastName + firstName : lastName + "\u69D8";
        },
    ],
    [
        'zh-CN',
        function (firstName, lastName, full) {
            return full ? "" + lastName + firstName : lastName;
        },
    ],
    [
        'zh-TW',
        function (firstName, lastName, full) {
            return full ? "" + lastName + firstName : lastName;
        },
    ],
]);
